import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'; // import {NgbPaginationModule, NgbAlertModule} from '@ng-bootstrap/ng-bootstrap';

// import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';

import { HmpgComponent } from './hmpg/hmpg.component'; // <-- NgModel lives here
import { ZylyComponent } from './zyly/zyly.component';
import { ZytdComponent } from './zytd/zytd.component';
import { ZytdItemDetailComponent } from './zytd-item-detail/zytd-item-detail.component';
import { JcalComponent } from './jcal/jcal.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { DtzxComponent } from './dtzx/dtzx.component';
import { YjzxComponent } from './yjzx/yjzx.component';
import { CpxflComponent } from './cpxfl/cpxfl.component';
import { CptxlComponent } from './cptxl/cptxl.component';
import { CpmcuComponent } from './cpmcu/cpmcu.component';


@NgModule({
  declarations: [
    AppComponent,
    HmpgComponent,
    ZylyComponent,
    ZytdComponent,
    ZytdItemDetailComponent,
    JcalComponent,
    AboutComponent,
    ContactComponent,
    DtzxComponent,
    YjzxComponent,
    CpxflComponent,
    CptxlComponent,
    CpmcuComponent,
  ],
  imports: [
    BrowserModule,
    NgbModule, // NgbPaginationModule, NgbAlertModule,
    AppRoutingModule,
    FormsModule,
  ],
  providers: [
    // {provide:LocationStrategy, useClass: HashLocationStrategy}
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [
    AppComponent,
  ],
  exports: [

  ],
})

export class AppModule { }

